import { ErrorMessage, Field, FormikProvider, useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { CommonPageHeading } from '../../CommonUtils/CommonHeading/CommonPageHeading'
import * as Yup from 'yup';
import * as jnb from 'react-bootstrap';
import { BsChevronDown } from 'react-icons/bs';
import { FaDownload } from 'react-icons/fa';
import { failureAlert, successAlert } from '../../CommonUtils/CommonPopupAndAlerts/SweetAlerts';
import { ERROR_MSG, handleKeyPressNumeric, Mobile_Msg, MOBILE_VALIDATION, public_url } from '../../CommonUtils/Validations/RegularExpAndVar';
import { config } from '../../CommonUtils/CommonUrl/CommonUrls';
import { EmpanelImageBucket, EmpanelImageOnlyBucket } from '../../CommonUtils/CommonFileUpload/ImageBucket';
import axios from "axios";

export default function EmpanelmentForm() {

    return (
        <div 
            style={{ 
                display: "flex", 
                justifyContent: "center", 
                alignItems: "center", 
                height: "100vh",   // Full screen height
                backgroundColor: "#f8f9fa" // Light background
            }}
        >
            <a
                href="https://labour.ap.gov.in/empanelmentform"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                    display: "inline-block",
                    padding: "16px 32px",
                    backgroundColor: "#007bff",
                    color: "#fff",
                    textDecoration: "none",
                    borderRadius: "8px",
                    fontSize: "18px",
                    fontWeight: "bold",
                    fontFamily: "Arial, sans-serif",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                    transition: "all 0.3s ease",
                    textAlign: "center",
                    lineHeight: "1.5"
                }}
                onMouseOver={(e) => {
                    e.target.style.backgroundColor = "#0056b3";
                    e.target.style.transform = "scale(1.05)";
                }}
                onMouseOut={(e) => {
                    e.target.style.backgroundColor = "#007bff";
                    e.target.style.transform = "scale(1)";
                }}
            >
                Click here to go to   "Application for Empanelment of Third Party Firms <br />
                for Labour Regulatory Compliance"
            </a>
        </div>
    )
}
